/* eslint-disable import/no-unused-modules */
export const RXDB_PREFIX = 'glade';
export const PREVIOUS_RXDB_PREFIX = 'noodle';

export const RESET_DB_KEY = 'rxdb.reset';
export const CURRENT_RXDB_SUFFIX_KEY = 'rxdb.suffix';
export const CURRENT_RESET_NUMBER = '7';

export const IS_DEV_MODE = process.env.NODE_ENV === 'development';

export const DATE_UNIX_SCHEMA = {
  maximum: 9999999999999,
  minimum: 0,
  multipleOf: 1,
  type: 'number',
} as const;

export const DATE_TIME_ISO_SCHEMA = {
  format: 'iso-date-time',
  nullable: true,
  type: 'string',
} as const;

export const DATE_ISO_SCHEMA = {
  format: 'date',
  type: 'string',
} as const;

export const MAX_CACHE_TIME = 1000 * 60 * 60 * 24; // 24 hours

export const REPLICATION_INFO_ID = 'replicationInfo';
export const LAST_REPLICATED_DATE_KEY = 'lastReplicatedDate';

export const RX_LOCAL_REPLICATION_INFO = {
  INITIAL_DATE_KEY: 'initial-date',
  KEY: 'rx-local-replication-info',
};

export enum REPLICATION_INFO_STATUS {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  ERROR = 'error',
  IDLE = 'idle',
  PAUSED = 'paused',
}

export const MIN_QUESTIONNAIRES_PER_CREATOR = 5;
export const MAX_QUESTIONNAIRES_PER_CREATOR = 30;

/**
 * The minimum amount of memory in MB that is required to use RxDB.
 */
export const MINIMUM_AVAILABLE_MEMORY_IN_MB = 3000;